import { createSlice } from '@reduxjs/toolkit';
import {
  processSituation,
  processSituations,
  sendSituationOpenedNotification,
} from '../thunks/monitoring';
import { resetSituations } from './situations';

export const INITIAL_STATE = {
  situationToProcess: null,
  isProcessing: false,
  currentSituations: [],
  status: 'idle',
  error: null,
};

export const monitoringSlice = createSlice({
  name: 'monitoring',
  initialState: INITIAL_STATE,
  reducers: {
    setSituationToProcess: (state, action) => {
      const { situationId, deviceId, roundId } = action.payload;

      state.situationToProcess = {
        situationId,
        deviceId,
        roundId: roundId ?? null,
      };
    },
    discardSituationToProcess: (state) => {
      state.situationToProcess = null;
      state.isProcessing = false;
      state.status = 'idle';
      state.error = null;
    },
    addCurrentSituation: (state, action) => {
      const situationId = action.payload;
      if (!state.currentSituations.includes(situationId)) {
        state.currentSituations.push(situationId);
      }
    },
    removeCurrentSituation: (state, action) => {
      const situationId = action.payload;
      state.currentSituations = state.currentSituations.filter(
        (id) => id !== situationId
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendSituationOpenedNotification.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(sendSituationOpenedNotification.fulfilled, (state) => {
        state.status = 'fulfilled';
        state.error = null;
      })
      .addCase(sendSituationOpenedNotification.rejected, (state, action) => {
        state.status = 'rejected';
        state.error = action.error;
        state.situationToProcess = null;
      })
      .addCase(processSituation.pending, (state) => ({
        ...state,
        isProcessing: true,
      }))
      .addCase(processSituation.fulfilled, (state, action) => {
        const { id: situationId } = action.payload;
        // Remover la situación de currentSituations cuando se procesa
        state.currentSituations = state.currentSituations.filter(
          (id) => id !== situationId
        );
        // Reset del estado de processing
        state.isProcessing = false;
        state.situationToProcess = null;
      })
      .addCase(processSituations.fulfilled, (state, action) => {
        const { successfulIds } = action.payload;
        // Remover las situaciones procesadas de currentSituations
        if (successfulIds?.length > 0) {
          state.currentSituations = state.currentSituations.filter(
            (id) => !successfulIds.includes(id)
          );
        }
        state.isProcessing = false;
      })
      .addCase(resetSituations, () => INITIAL_STATE);
  },
});

export const {
  setSituationToProcess,
  discardSituationToProcess,
  addCurrentSituation,
  removeCurrentSituation,
} = monitoringSlice.actions;

export default monitoringSlice.reducer;
